module.exports = __webpack_public_path__ + "static/media/peace.c6f92ab9.jpg";